import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import React from 'react';
import { Row, Col, Alert, Container } from 'reactstrap';
import PersonIcon from '@mui/icons-material/Person';
import LaptopChromebookIcon from '@mui/icons-material/LaptopChromebook';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { loginUser } from '../../store/actions';
import CarouselPage from '../AuthenticationInner/CarouselPage';
import getUrlParams from '../../components/Common/getUrlParams/getUrlParams';
import './index.scss';

interface LoginProps {
    history: object;
}

const Demo = ({ history }: LoginProps) => {
    const dispatch = useDispatch();
    const { url, brand, result } = getUrlParams({ name: 'nwkID' });
    const { error } = useSelector((state: any) => ({
        error: state.login.error,
    }));

    const handleValidSubmit = ({ email = "", password = "" }) => {
        dispatch(loginUser({  email, password }, history, 37370));
    };

    return (
        <React.Fragment>
            <PageTitle>
                <title>Login | {brand.name}</title>
            </PageTitle>
            <div className="auth-page">
                <Container fluid className="p-0">
                    <Row className="g-0">
                        <Col lg={4} md={5} className="col-xxl-3">
                            <div className="auth-full-page-content d-flex p-sm-5 p-4">
                                <div className="w-100">
                                    <div className="d-flex flex-column h-100">
                                        <div className="mb-4 mb-md-5 text-center">
                                            <Link to={url} className="d-block auth-logo">
                                                {<img src={brand.logo} alt="" height="60" />}
                                            </Link>
                                        </div>
                                        <div className="auth-content demo-content">
                                            <div className="text-center">
                                                <h5 className="mb-0">Welcome Back!</h5>
                                                <p className="text-muted mt-2">Sign in to continue to {brand.name}.</p>
                                            </div>
                                        <div>
                                            <button onClick={(event: any) => handleValidSubmit({ email: "hub.client@innobo.co", password: "1234567" })}  className='btn btn-primary w-75 waves-effect waves-light d-flex flex-row justify-content-center gap-3 align-items-center demo-button'><PersonIcon></PersonIcon><span>Your Access</span></button> 
                                            <button onClick={(event: any) => handleValidSubmit({ email: "hub.sub-client@innobo.co", password: "1234567" })} className='btn btn-primary w-75 waves-effect waves-light d-flex flex-row justify-content-center gap-3 align-items-center demo-button'><LaptopChromebookIcon></LaptopChromebookIcon><span>Your Client &apos;s Access</span></button>
                                        </div>
                                        </div>
                                        <div className="mt-4 mt-md-5 text-center">
                                            <p className="mb-0">© {new Date().getFullYear() + ' ' + brand.name}.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <CarouselPage />
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(Demo);
